import { FileDto } from "@shared/service-proxies/service-proxies";

export class SimpleContentSnapshotModel {
    fileDto: FileDto;
    constructor() {
        this.fileDto = new FileDto();
    }
}
